import React, { useState } from "react";
import { useParams } from "react-router-dom";
import CompanyHealthcheckPage from "storybook-dashboard/dashboard/health/page";
import { ExportRow } from "storybook-dashboard/dashboard/export/company/page";
import { companyDispatchToDownload } from "storybook-dashboard/dashboard/export/company/fetch";

const getName = (data) => data?.get("project_name") || data?.get("Reporting Package");

const getHealthFilters = () => {
  let host = location.hostname;
  if (host.startsWith("sizewellc") || host.startsWith("localhost")) {
    return [
      {
        title: "Report type",
        options: [
          {
            name: "All",
            filter: null,
          },
          {
            name: "Environment",
            filter: (data) => getName(data)?.includes("Environment Report"),
          },
          {
            name: "People/Workforce",
            filter: (data) => getName(data)?.includes("People/Workforce Report"),
          },
          {
            name: "Social Value",
            filter: (data) => getName(data)?.includes("Social Value"),
          },
        ],
      },
    ];
  }
  return [];
};

function DownloadingFileMessage() {
  return (
    <p className="font-weight-bold">
      Downloading file... Please do not refresh or close this tab. This process takes a few minutes, please wait.
    </p>
  );
}

export default function CompanyHealthPage(props) {
  const [reportStatusPending, setReportStatusPending] = useState(false);
  const { _companyId } = useParams();
  return (
  <>        
    <ExportRow
      title={"Export report status"}
      description={
        <>
          {reportStatusPending && <DownloadingFileMessage />}
          Generate a CSV file which contains all the reports indicating their status, whether the report is
          approved, pending approval, requires revision, or if no report has been submitted.
        </>
      }
      fetchHandler={() =>
        companyDispatchToDownload({
          companyId: _companyId,
          actionName: "REPORT_STATUS_CSV",
          fileName: "report_status.csv",
          setPending: setReportStatusPending,
          pending: reportStatusPending,
        })
      }
    />
    <CompanyHealthcheckPage {...props} filters={getHealthFilters()} />
  </>
  );
}
